import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EmbeddedContextService } from './embedded-context.service';

@Injectable( {
  providedIn: 'root'
} )
export class SnackBarMessagesService {

  constructor(
    private readonly snackBar: MatSnackBar,
    private readonly embeddedContextService: EmbeddedContextService
  ) { }

  showSuccessMessage( message: string, buttonText: string ) {
    if ( this.embeddedContextService.isEmbeddedRoute() ) {
      return;
    }

    this.snackBar.open( message, buttonText, {
      duration: 9000,
      panelClass: 'success-snack-bar',
      horizontalPosition: 'center',
      verticalPosition: 'bottom'
    } );
  }

  showErrorMessage( message: string, buttonText: string ) {
    if ( this.embeddedContextService.isEmbeddedRoute() ) {
      return;
    }

    this.snackBar.open( message, buttonText, {
      duration: 9000,
      panelClass: 'error-snack-bar',
      horizontalPosition: 'center',
      verticalPosition: 'bottom'
    } );
  }
}
